import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: {
    value: number;
    label: string;
  };
  onClick?: () => void;
  iconColor?: string;
}

export function StatCard({ title, value, icon: Icon, trend, onClick, iconColor = "text-primary" }: StatCardProps) {
  const isPositiveTrend = trend && trend.value > 0;
  const isNegativeTrend = trend && trend.value < 0;

  return (
    <motion.div
      whileHover={onClick ? { y: -4, scale: 1.02 } : {}}
      transition={{ duration: 0.2 }}
    >
      <Card 
        className={`${onClick ? "cursor-pointer hover:shadow-lg transition-shadow" : ""}`}
        onClick={onClick}
      >
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{title}</CardTitle>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{value}</div>
          {trend && (
            <div className="flex items-center gap-2 mt-2">
              <Badge 
                variant={isPositiveTrend ? "default" : isNegativeTrend ? "destructive" : "secondary"}
                className="text-xs"
              >
                {isPositiveTrend ? "↑" : isNegativeTrend ? "↓" : "→"} {Math.abs(trend.value)}%
              </Badge>
              <p className="text-xs text-muted-foreground">{trend.label}</p>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
